var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcGuidePersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51901 9.90884C9.27212 9.21778 8.72809 8.60713 7.9713 8.1716C7.21451 7.73607 6.28725 7.5 5.33333 7.5C4.37942 7.5 3.45216 7.73607 2.69537 8.1716C1.93858 8.60713 1.39455 9.21778 1.14766 9.90884",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.33366,
    cy: 3.16667,
    r: 2.16667,
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcGuidePersonIcon);
export default __webpack_public_path__ + "static/media/cp-pc-guide-person-icon.fc86ca454634ef1c95efd8dc96b82e4d.svg";
export { ForwardRef as ReactComponent };